import React, { createRef } from 'react';
import { VariableSizeList as List } from 'react-window'; // Changed to VariableSizeList for dynamic item sizes
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { browserHistory } from 'react-router';
import Image from '../components/image';
import $ from 'jquery';
class DqChart extends React.Component {
  BATCH_SIZE = 2; // This will align with attributesPerLoad for fetching
  ITEM_HEIGHT = 150;
  ROW_GAP = 20;

  constructor(props) {
    super(props);

    const initialChartDataDict = props.chartData || {};
    const initialChartKeys = Object.keys(initialChartDataDict);

    this.state = {
      chartData: initialChartDataDict,
      chartKeys: initialChartKeys,
      chartGridWidth: this.calculateChartGridWidth(), //window.innerWidth / 2,
      chartHeight: this.calculateChartHeight(),
      isLoadingMore: false,
      // --- New state variables for loadMoreData integration ---
      allAttributeIdsForDataset: [], // You need to populate this, likely from props or an initial API call
      currentAttributePageIndex: 0,
      attributesPerLoad: this.BATCH_SIZE, // Align with BATCH_SIZE
      selectedDatasetId: null, // You need to populate this
      selectedIntegrationId: null, // You need to populate this
      fullAttributeList: this.props.fullAttributeList, // You need to populate this
      saveList: this.props.saveList,
      startIndex: 5, // Used for slicing fullAttributeList
      endIndex: 10,   // Used for slicing fullAttributeList
      // --------------------------------------------------------

      inputData: this.props.inputData,
      activeHighlightedMetaId: null, // Existing for left panel highlighting
      lastSentBottomChartId: null,   // <--- ADD THIS NEW STATE VARIABLE
      bottomPanelData: this.props.bottomPanelData,
      incidentchartData: this.props.incidentchartData,
      selectedMeticsName: this.props.selectedMeticsName,
      isCheckedIncidents: this.props.isCheckedIncidents,
      selectedDatasetAttrId: this.props.selectedDatasetAttrId,
      hasMoreData: this.props.hasMoreData,
      selectedEnvI: this.props.selectedEnvId,
      selectedDatasetName: this.props.selectedDatasetName,
      selectedDatasetAttrName: this.props.selectedDatasetAttrName,
      resizeCounter: 1, // Add resizeCounter
    };

    this.chartRefs = {}; // Create references for chart containers
    this.observer = null; // Intersection Observer instance
    this.listRef = createRef(); // Reference to VariableSizeList
    this.socket = null;


    this.calculateChartGridWidth = this.calculateChartGridWidth.bind(this);
    this.calculateChartHeight = this.calculateChartHeight.bind(this);
    this.getItemSize = this.getItemSize.bind(this); // Bind the new method
    // this.handleItemsRendered = this.handleItemsRendered.bind(this);
    // Bind the handler to the component instance
    this.handleChartGridResize = this.handleChartGridResize.bind(this);
  }

  // Remove event listener when component unmounts
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleChartGridResize);
  }

  handleMapKpi = () => {
    browserHistory.push({
      pathname: '/configure',
      state: {
        configureTab: 'business',
        businessSubTab: 'domainMapping'
      }
    });
  };

  handleEnableKpi = () => this.handleMapKpi();


    // Handle Dynamic Chart Height
  calculateChartHeight = () => {
    const screenHeight = window.innerHeight;
    // These values are examples and might need fine-tuning based on your layout.
    // They represent the total height available for the list after deducting headers/footers.
    if (screenHeight > 900) {
      return screenHeight - 150; // Less deduction for larger screens
    } else if (screenHeight > 700) {
      return screenHeight - 180; // Medium deduction
    } else {
      return screenHeight - 210; // More deduction for smaller screens
    }
  };

  // Update state with new chart grid width on resize
   handleChartGridResize = () => {
    // this.setState({ chartGridWidth: this.calculateChartGridWidth() });
        let max = 10000; 
        const randomInt = Math.floor(Math.random() * max);
    this.setState({
      chartGridWidth: this.calculateChartGridWidth(),
      chartHeight: this.calculateChartHeight(), // Update chartHeight on resize
      resizeCounter: randomInt+this.state.resizeCounter + 1, // Increment resizeCounter
    });
    // Reset item sizes after resize to recalculate
    if (this.listRef.current) {
      this.listRef.current.resetAfterIndex(0);
    }
  };


  componentDidMount() {
    window.addEventListener('resize', this.handleChartGridResize);

    // Example: Initialize state variables that might come from props or initial fetches
    // You'll need to pass these as props from the parent or fetch them here
    this.setState({
      allAttributeIdsForDataset: this.props.allAttributeIdsForDataset || [], // Example prop
      fullAttributeList: this.props.fullAttributeList || [], // Example prop
      selectedDatasetId: this.props.selectedDatasetId || null, // Example prop
      selectedIntegrationId: this.props.selectedIntegrationId || null, // Example prop
      saveList: this.props.saveList || null, // Example prop
      bottomPanelData: this.props.bottomPanelData || {},
      incidentchartData: this.props.incidentchartData || {},
      selectedMeticsName: this.props.selectedMeticsName || "",
      isCheckedIncidents: this.props.isCheckedIncidents || false,
      currentBottomPanelData: this.props.currentBottomPanelData || false,
      selectedDatasetName: this.props.selectedDatasetName || false,
      selectedDatasetAttrName: this.props.selectedDatasetAttrName || false,
      
      // Potentially trigger initial load if no data exists
      // if (this.state.chartKeys.length === 0 && this.state.allAttributeIdsForDataset.length > 0) {
      //    this.loadMoreItems();
      // }
    });

  }
componentDidUpdate(prevProps, prevState) {
        $("#lt_dq").addClass("active");
  if (this.props.leftMenuCollapsed !== prevProps.leftMenuCollapsed) {
    this.handleChartGridResize();
  }
  if (this.props.isCheckedIncidents !== prevProps.isCheckedIncidents) {
    let filteredChartDetails = {};
    if (this.props.isCheckedIncidents === true) {
      // Use the incidentchartData from props (already filtered in parent component)
      filteredChartDetails = this.props.incidentchartData || {};
    } else {
      // When incidents are not checked, show all charts from props
      filteredChartDetails = this.props.chartData || {};
    }
    
    // Update both chartData and chartKeys to ensure list renders correctly
    const newChartKeys = Object.keys(filteredChartDetails);
    this.setState({ 
      isCheckedIncidents: this.props.isCheckedIncidents, 
      chartData: filteredChartDetails,
      chartKeys: newChartKeys  // Update chartKeys as well
    });
    
    // Reset item sizes when incidents filter changes
    if (this.listRef.current) {
      this.listRef.current.resetAfterIndex(0);
      this.listRef.current.scrollTo(0); // Scroll to the top to re-render from the beginning
    }
  }

  // Update chartData from props if it changes
  if (this.props.chartData !== prevProps.chartData) {
    const newChartDataDict = this.props.chartData || {};
    const newChartKeys = Object.keys(newChartDataDict);

    if (
      newChartDataDict !== prevState.chartData ||
      newChartKeys.length !== prevState.chartKeys.length ||
      !newChartKeys.every((key, index) => key === prevState.chartKeys[index])
    ) {
      // Only update if we're NOT in incident mode
      if (!this.state.isCheckedIncidents) {
        this.setState({
          chartData: newChartDataDict,
          chartKeys: newChartKeys,
        });
        // Reset item sizes when chart data changes
        if (this.listRef.current) {
          this.listRef.current.resetAfterIndex(0);
        }
      }
    }
  }

  // Update incidentchartData when it changes and we're in incident mode
  if (this.props.incidentchartData !== prevProps.incidentchartData) {
    const newIncidentChartData = this.props.incidentchartData || {};
    const newIncidentChartKeys = Object.keys(newIncidentChartData);
    
    // Update internal incidentchartData state
    this.setState({ incidentchartData: newIncidentChartData });
    
    // If currently showing incidents, also update the active chartData and chartKeys
    if (this.state.isCheckedIncidents) {
      this.setState({
        chartData: newIncidentChartData,
        chartKeys: newIncidentChartKeys,
      });
      // Reset item sizes when incident chart data changes
      if (this.listRef.current) {
        this.listRef.current.resetAfterIndex(0);
      }
    }
  }
  if (this.props.selectedMeticsName !== prevProps.selectedMeticsName) {
    this.setState({ selectedMeticsName: this.props.selectedMeticsName }, () => {
      // Reset sizes when selected metrics changes
      if (this.listRef.current) {
        this.listRef.current.resetAfterIndex(0);
        // Scroll to top when filtering by metrics
        this.listRef.current.scrollTo(0);
      }
    });
  }
  if (this.props.currentBottomPanelData !== prevProps.currentBottomPanelData) {
    this.setState({ currentBottomPanelData: this.props.currentBottomPanelData });
  }
}


// Handle Dynamic Chart Grid Width
calculateChartGridWidth = () => {
    const screenWidth = window.innerWidth;
  if (this.props.showChartFullscreen){
    return screenWidth; // No deduction in full screen for full panel width
  }
  const mainContent = document.querySelector(".qd-rt_main-content");
  if (mainContent && mainContent.clientWidth > 0) {
    return Math.max(0, screenWidth - mainContent.clientWidth);
  }
  else if (screenWidth > 1450) {
    return 414;
  } else if (screenWidth > 1200) {
    return 343;
  } else {
    return 293;
  }
};

  // New method to get item size dynamically, adding extra space after 3rd and 4th charts (indices 2 and 3)
  getItemSize = (index) => {
   // const baseSize = window.innerHeight <= 768 ? ( Math.ceil(this.state.chartKeys.length) === 1 || Math.ceil(this.state.chartKeys.length) === 2 || this.props.selectedMeticsName !== "" ? (window.innerHeight - 199) : 276 ) : ( Math.ceil(this.state.chartKeys.length) === 1 || Math.ceil(this.state.chartKeys.length) === 2 || this.props.selectedMeticsName !== "" ? (window.innerHeight - 199) : (window.innerHeight - 199) / 2);
  
  //  console.log("test"+Math.ceil(this.state.chartKeys.length))
  //  console.log(this.props.selectedMeticsName)
  //  console.log("&&&&&&&&&&&&")
 
   let  baseSize = window.innerHeight <= 768 ? 
   ( Math.ceil(this.state.chartKeys.length) === 1 || Math.ceil(this.state.chartKeys.length) === 2 /*|| this.props.selectedMeticsName !== ""*/ ? (window.innerHeight - 255) : 276 )
   : ( Math.ceil(this.state.chartKeys.length) === 1 || Math.ceil(this.state.chartKeys.length) === 2 /*|| this.props.selectedMeticsName !== ""*/ ? (window.innerHeight - 255) : (window.innerHeight - 199) / 2);
  
   if(this.props.selectedMeticsName !== ""){
    baseSize = (window.innerHeight - 199)
    }
    // Logic for attribute title rendering (add 40px if title is rendered)
    let chartKeys = this.state.chartKeys || [];
    
    // Filter out dummy entries to get real chart keys
    let realChartKeys = chartKeys.filter((key) => !key.startsWith("dummy"));
    
    // Build the same row mapping to find metricId1 for this row
    // IMPORTANT: This must match the pairing logic in dq.js Row component
    let rowMap = [];
    let chartIdx = 0;
    while (chartIdx < realChartKeys.length) {
      let metricId1 = realChartKeys[chartIdx];
      let metricId2 = realChartKeys[chartIdx + 1];
      
      if (!metricId1) break;
      
      if (!metricId2) {
        rowMap.push({ metricId1, metricId2: null });
        break;
      }
      
      let id1 = metricId1.split("_")[0];
      let id2 = metricId2.split("_")[0];
      let type1 = metricId1.split("_")[2]; // "dt" or "attr"
      let type2 = metricId2.split("_")[2]; // "dt" or "attr"
      
      // RULE 1: Same ID - pair them
      if (id1 === id2) {
        rowMap.push({ metricId1, metricId2 });
        chartIdx += 2;
      } 
      // RULE 2: Both dataset-level - pair them
      else if (type1 === "dt" && type2 === "dt") {
        rowMap.push({ metricId1, metricId2 });
        chartIdx += 2;
      }
      // RULE 3: Attribute-level - render alone
      else if (type1 === "attr") {
        rowMap.push({ metricId1, metricId2: null });
        chartIdx += 1;
      }
      // RULE 4: Fallback - render alone
      else {
        rowMap.push({ metricId1, metricId2: null });
        chartIdx += 1;
      }
    }
    
    let metricId1 = rowMap[index]?.metricId1;
    let prevRowMetricId1 = rowMap[index - 1]?.metricId1;
    
    // Only show title for attribute-level charts and when starting a new attribute
    let shouldRenderTitle = this.props.selectedDatasetAttrId === "" && 
                            metricId1 !== undefined && 
                            metricId1.includes("_attr") &&  // Only for attribute-level charts
                            (index === 0 || (metricId1 && prevRowMetricId1 && metricId1.split("_")[0] !== prevRowMetricId1.split("_")[0]));
    let size = baseSize;
    if (shouldRenderTitle) {
      size += 34;
    }
    // console.log("Calculated item size for index", index, "is", size, "baseSize:", baseSize, "shouldRenderTitle:", shouldRenderTitle);
    // if (index === 2 || index === 3) {
    //   size += extraSpace;
    // }
    
    size = this.ROW_GAP+size;
    // console.log("Final item size for index", index, "is", size);
    // console.log(Math.ceil(this.state.chartKeys.length))
   
    return this.props.showChartFullscreen ? size + 18 : size;
  };

  render() {
  let chartKeys = [];

if (this.state.chartData) {
  chartKeys = Object.keys(this.state.chartData);
}

const hasOpacity = document
  .querySelector(".qd-rt_main-content")
  ?.classList.contains("opacity-50");

if (!chartKeys.length) {
  const isKpiSelected = this.props.selectedLeftPanelType === "KPI";

  const kpi_compute_check = this.props.metricsValueResponse;

  // Get the currently selected KPI
  const selectedKpi = Object.values(kpi_compute_check?.kpis || {})
    .flat()
    .find(
      (kpi) => String(kpi.value ?? kpi.id) === String(this.props.selectedKpiId)
    );

  const hasMappedDataset = selectedKpi?.integrations?.some((integration) => {
    const datasets = selectedKpi.datasets?.[integration.value];
    return Array.isArray(datasets) && datasets.length > 0;
  });
  const isKpiUnmapped = !selectedKpi || !hasMappedDataset;

  // Check whether KPI computation is disabled
  const isKpiDisabled = selectedKpi?.computation_enabled === false;

  // Get KPI name
  const kpiName = selectedKpi?.label || "KPI";

  return (
    <div
      className="qd-rt_chart-widget-row tw-bg-white dark:tw-bg-[#1E1E2D]"
      style={{
        width: "100%",
        height: this.props.showChartFullscreen
          ? document.documentElement.clientHeight
          : window.innerHeight - 231,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "5px",
        marginBottom: "1px",
        borderRadius: "5px"
      }}
    >
      {hasOpacity ? (
        "Loading..."
      ) : this.props.partitionError ? (
        <>
          Please select the <b>Include Partitions</b> checkbox.
        </>
      ) : isKpiSelected && isKpiUnmapped ? (
        // No KPI mapped placeholder
        <div className="placeholder-msg !tw-pt-0">
          <div className="placeholder-msg__icon">
            <Image src="icon_placeholder_pipeline_configure" />
          </div>

          <div className="placeholder-msg__text">
            <h6>No KPI mapped</h6>
            <p className="tw-w-80 tw-mx-auto">
              Map a KPI to start tracking its performance and view
              relevant metrics.
            </p>
          </div>

          <div className="placeholder-msg__action">
            <button
              onClick={this.handleMapKpi}
              className="btn btn-outline-primary btn-circle"
            >
              <i>
                <FontAwesomeIcon icon={faPlusCircle} />
              </i>
              Map KPI
            </button>
          </div>
        </div>
      ) : isKpiSelected && isKpiDisabled ? (
        // Disabled KPI placeholder
        <div className="placeholder-msg !tw-pt-0">
          <div className="placeholder-msg__icon">
            <Image src="icon_placeholder_pipeline_configure" />
          </div>

          <div className="placeholder-msg__text">
            <h6>{kpiName} has been disabled</h6>
            <p className="tw-w-80 tw-mx-auto">
              Enable the KPI to start tracking its performance.
            </p>
          </div>

          <div className="placeholder-msg__action">
            <button
              onClick={this.handleEnableKpi}
              className="btn btn-outline-primary btn-circle"
            >
              <i>
                <FontAwesomeIcon icon={faPlusCircle} />
              </i>
              Enable KPI
            </button>
          </div>
        </div>
      ) : (
        "No Data Found"
      )}
    </div>
  );
}
// Filter out dummy entries to calculate actual number of rows
let realChartKeys = chartKeys.filter((key) => !key.startsWith("dummy"));

// Calculate number of rows based on smart pairing logic
// This mirrors the logic in Row component
let numRows = 0;
let chartIdx = 0;
while (chartIdx < realChartKeys.length) {
  let metricId1 = realChartKeys[chartIdx];
  let metricId2 = realChartKeys[chartIdx + 1];
  
  if (!metricId1) break;
  
  if (!metricId2) {
    numRows++;
    break;
  }
  
  let id1 = metricId1.split("_")[0];
  let id2 = metricId2.split("_")[0];
  let type1 = metricId1.split("_")[2]; // "dt" or "attr"
  let type2 = metricId2.split("_")[2]; // "dt" or "attr"
  
  // RULE 1: If both are from the same ID (dataset or attribute), pair them together
  if (id1 === id2) {
    numRows++;
    chartIdx += 2;
  } 
  // RULE 2: If both are dataset-level charts (_dt), pair them together
  else if (type1 === "dt" && type2 === "dt") {
    numRows++;
    chartIdx += 2;
  }
  // RULE 3: If current chart is attribute-level (_attr), render it alone (each attribute gets own row)
  else if (type1 === "attr") {
    numRows++;
    chartIdx += 1;
  }
  // RULE 4: Otherwise, render current chart alone
  else {
    numRows++;
    chartIdx += 1;
  }
}

return (
  <>
    <List
      key={`${this.props.incidentPanelState}-${this.props.isCheckedIncidents}-${this.state.resizeCounter}-${this.props.showChartFullscreen}-${this.props.selectedMeticsName}-${this.props.leftMenuCollapsed}`} // Force re-mount and re-render from the beginning on toggle or resize
      itemData={[...chartKeys]}
      // height={this.state.chartHeight} // Use dynamic chartHeight
      //width={window.innerWidth - this.state.chartGridWidth } // need to apply full screen 
      width={this.props.showChartFullscreen ? window.innerWidth : window.innerWidth - this.state.chartGridWidth}
      height={this.props.showChartFullscreen ?  window.innerHeight : window.innerHeight - 231}
      // height: calc(100% - 6px); need to apply full screen 
      // width={window.innerWidth - this.state.chartGridWidth} // Ensure the grid takes full width of the window
      // itemSize={Math.ceil(this.state.chartKeys.length) === 1 || Math.ceil(this.state.chartKeys.length) === 2 || this.props.selectedMeticsName !== "" ? (window.innerHeight - 199) : (window.innerHeight - 199) / 2}
      itemSize={this.getItemSize} // Use the dynamic getItemSize function
      // itemCount={Math.ceil(this.state.chartKeys.length) + (hasMoreData ? 1 : 0)}
      itemCount={numRows}  // Use number of rows instead of number of charts
      // onScroll={this.handleScroll}
      onItemsRendered={this.props.handleItemsRendered} // Track visible items
      ref={this.listRef} // Reference to the list for resetting sizes
    >
      {this.props.Row}
    </List>
  </>
);

    // return (
    //   <>
    //     <List
    //       itemData={[...chartKeys]}
    //       // height={this.state.chartHeight} // Use dynamic chartHeight
    //       //width={window.innerWidth - this.state.chartGridWidth } // need to apply full screen 
    //       width={this.props.showChartFullscreen ? window.innerWidth : window.innerWidth - this.state.chartGridWidth}
    //       height={this.props.showChartFullscreen ?  document.documentElement.clientHeight: window.innerHeight - 199}
    //       // height: calc(100% - 6px); need to apply full screen 
    //       // width={window.innerWidth - this.state.chartGridWidth} // Ensure the grid takes full width of the window
    //       // itemSize={Math.ceil(this.state.chartKeys.length) === 1 || Math.ceil(this.state.chartKeys.length) === 2 || this.props.selectedMeticsName !== "" ? (window.innerHeight - 199) : (window.innerHeight - 199) / 2}
    //       itemSize={this.getItemSize} // Use the dynamic getItemSize function
    //       // itemCount={Math.ceil(this.state.chartKeys.length) + (hasMoreData ? 1 : 0)}
    //       itemCount={this.state.chartKeys.length}
    //       // onScroll={this.handleScroll}
    //       onItemsRendered={this.props.handleItemsRendered} // Track visible items
    //       ref={this.listRef} // Reference to the list for resetting sizes
    //     >
    //       {this.props.Row}
    //     </List>
    //   </>
    // );
  }
}

export default DqChart;
